import store from "@/store/index";
import {post} from "@/plugins/axios";

/****************************实习岗位管理*************************************************/
/*
 * 实习岗位列表
 * @constructor jack
 * */
export const stationList = (name, page, list_rows, u_token = store.state.token2
) => post("/org/stationList", {
  name,
  page,
  list_rows, u_token
});

/*
 * 实习岗位添加
 * @constructor jack
 * */
export const stationAdd = (sx_name, address, stu_num, shixi_time, end_time, zhize, tiaojian, yaoqiu, daiyu, remark, salary_min,
                           salary_max, sx_id, u_token = store.state.token2
) => post("/org/stationAdd", {
  sx_name, address, stu_num, shixi_time, end_time, zhize, tiaojian, yaoqiu, daiyu, remark, salary_min,
  salary_max, sx_id, u_token
});

/*
 * 实习岗位详情
 * @constructor jack
 * */
export const station = (sx_id, u_token = store.state.token2) => post("/org/station", {sx_id, u_token});

/*
 * 实习岗位 对应的机构信息
 * @constructor jack
 * */
export const getOrgDesc = (sx_id, u_token = store.state.token2) => post("/org/getOrgDesc", {sx_id, u_token});




/*
 * 实习岗位删除
 * @constructor jack
 * */
export const stationDel = (sx_id, u_token = store.state.token2) => post("/org/stationDel", {sx_id, u_token});

/*
 * 志愿列表
 * @constructor jack
 * */
export const volunteerList = (sx_id, level, stu_name, page, list_rows, u_token = store.state.token2
) => post("/org/volunteer", {
  sx_id,
  level,
  stu_name,
  page,
  list_rows, u_token
});

/*
 * 志愿详情
 * @constructor jack
 * */
export const volunteerFind = (u_token = store.state.token2
) => post("/org/volunteerFind", {
  u_token
});

/*
 *  发送面试邀请
 * @constructor jack
 * */
export const addInvite = (zy_id, mian_time, mian_type, remark, u_token = store.state.token2
) => post("/org/addInvite", {
  zy_id, mian_time, mian_type, remark, u_token
});

/*
 * 志愿拒绝
 * @constructor jack
 * */
export const volunteerState = (zy_id, status, remark, u_token = store.state.token2
) => post("/org/volunteerState", {
  zy_id, status, remark, u_token
});

/*
 * 志愿录取
 * @constructor jack
 * */
export const volunteerEmploy = (status, zy_id, remark, bd_time, start_date, end_date, address, contact_name, contact_phone, cailiao, qita, u_token = store.state.token2
) => post("/org/volunteerState", {
  status, zy_id, remark, bd_time, start_date, end_date, address, contact_name, contact_phone, cailiao, qita, u_token
});


/****************************实习生管理*************************************************/
/*
 * 学生管理列表
 * @constructor jack
 * */
export const stationClass = (stu_name, status, sx_id, page, list_rows, u_token = store.state.token2
) => post("/org/stationClass", {
  stu_name,
  status,
  sx_id,
  page,
  list_rows, u_token
});

/*
 * 实习生编辑报道
 * @constructor jack
 * */
export const volunteerSign = (status, id,start_date,end_date,gw, u_token = store.state.token2
) => post("/org/volunteerSign", {
  status, id,start_date,end_date,gw, u_token
});




/*
 * 学生管理评价
 * @constructor jack
 * */
export const stationClassAppraise = (content, zy_id, u_token = store.state.token2
) => post("/org/stationClassAppraise", {
  content, zy_id, u_token
});

/*
 * 学生评价获取
 * @constructor jack
 * */
export const getStudentComment = (id, u_token = store.state.token2
) => post("/org/getStudentComment", {
  id, u_token
});
/*
 * 学生设置实习评价
 * @constructor jack
 * */
export const setStudentComment = (id,content, u_token = store.state.token2
) => post("/org/setStudentComment", {
  id,content, u_token
});
/*
 * 学生实习结束
 * @constructor jack
 * */
export const volunteerFinish = (id,finish_type,start_date,end_date,gw,remark, u_token = store.state.token2
) => post("/org/volunteerFinish", {
  id,finish_type,start_date,end_date,gw,remark, u_token
});



/*
 * 实习基地信息添加/修改
 * @constructor jack
 * */
export const updateOrgS = (org_name, org_code, org_license, username, zhiwu, phone, email, region_text, address, longitude, latitude, way, huanjing, huanjing_file, shixi_desc, jihua_num, month, shizi, gangwei, remark, shen_type, u_token = store.state.token2
) => post("/org/updateOrgS", {
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  huanjing,
  huanjing_file,
  shixi_desc,
  jihua_num,
  month,
  shizi,
  gangwei,
  remark,
  shen_type,
  u_token
});


/*
* 获取机构简介
* @constructor jack
* */
export const getDescInfo = (u_token = store.state.token2
) => post("/org/getDescInfo", {
  u_token
});

/*
* 保存机构简介
* @constructor jack
* */
export const setDescInfo = (logo, desc, name, phone, address, email, env_img, site_url, u_token = store.state.token2
) => post("/org/setDescInfo", {
  logo, desc, name, phone, address, email, env_img, site_url, u_token
});

/*
* 保存机构简介
* @constructor jack
* */
export const getStatistics = ( u_token = store.state.token2
) => post("/org/statistics", {
  u_token
});
